module.exports = __webpack_public_path__ + "img/4.436fd0a1.jpg";